export enum HighlightType {
	None = 0xffffff,
	Tagged = 0xffff00,
	Highlight = 0xcccccc,
	Golden = 0xFFD700,
	Error = 0x661111,
	Effect = 0x111111, //just has to be something that isn't None so glowsprite isn't hidden
}